<div class="container-fluid  row_banner ">
    <app-header></app-header>
    <div class="container">
        <div class="row  text-center justify-content-center">
            <div class="col-lg-9 col-md-9 mb-4" id="footergrammartext">
                <h1 class="w-100 fnt-w600-40 tit">AI Thesis Statement Generator </h1>
                <span class="w-100 d-inline-block main_text mt-40">Develop strong, focused thesis statements that
                    support academic writing with clarity and purpose.</span>
            </div>
        </div>
        <!-- Editor -->
        <!-- <div class="row  text-center justify-content-center">
            <div class="col-lg-7 col-md-9 col-12 "> -->
        <div class="custom-card">
            <p class="text-left px-3" id="eFsubText2" [ngStyle]="{'color': color}" *ngIf="eFsubIF ">
                <i class="fas fa-check-circle" aria-hidden="true"></i>{{eFsubText2}}
            </p>
            <form class="aiform">
                <div>
                    <div class="">
                        <label for="description" class="aiLabel">Enter Target Audience*</label>
                        <textarea id="form_target" name="form_target" class="form-control bd-light" rows="1"
                            spellcheck="false" data-gramm="false"
                            placeholder="Example: Advanced Data Sciences Professors" required></textarea>
                    </div>
                    <div class="mt10">
                        <label for="format" class="aiLabel">Enter Thesis topic detail*</label>
                        <textarea id="form_detailed" name="form_detailed" class="form-control bd-light" rows="3"
                            spellcheck="false" data-gramm="false"
                            placeholder="Example: I am writing a research paper about the usage of penalty takers data to predict penalty directions to help goal keepers."
                            required></textarea>
                    </div>

                </div>
                <br>
                <div class="input-group-append btn-submit-div">
                    <button type="submit" class="btn btn-dark m-0 btn-submit" value="Submit"
                        (click)="eFormSubmission($event)">
                        <i class="fa fa-spinner fa-pulse ml-2 mr-1" *ngIf="loaderAlert"></i> Submit </button>
                    <button *ngIf="output_display" type="submit" class="btn btn-dark m-0 btn-refresh "
                        (click)="reFreshWindow()">
                        Start New Search </button>
                </div>

            </form>
            <div class="outputDisplay mt-3" *ngIf="output_display">
                <div class="outputtop">
                    <div>
                        <p class="outputtopTxt">
                            Your thesis statement ideas are below
                        </p>
                    </div>

                    <div class="outputtopButton tooltipss" (click)="copyToClipboard()" role="button" tabindex="0"
                        (keydown.enter)="copyToClipboard()">
                        <span class="tooltiptext">Copy</span>
                        <span class="tooltiptext" id="copried_txt" *ngIf="copiedtext">Copied</span>
                        <img src="../../assets/images/About us-assets/copy-frame.svg" alt="copy-frame" height="18px"
                            width="18px">
                        <p class="">Copy to clipboard</p>
                    </div>
                </div>
                <div class="responseD">
                    <div class="responseO" [innerHTML]="output"></div>

                </div>
            </div>
        </div>
        <!-- </div>
        </div> -->
    </div>
</div>
<!-- <main id="thesis-statement-generator">
    <section class="top-margin">
        <div class="container">
            <div class="statement-generator">
                <div class="row text-center justify-content-center">
                    <div class="col-lg-6 col-md-9 mb-4">
                        <div class="statement-detail">
                            <h2 class="statement-title">
                                How to Use Thesis Statement Generator?
                            </h2>
                            <p class="statmente-description">Follow a few quick steps without any professional
                                expertise
                                and
                                you will have a polished, academic-ready
                                statement in no
                                time</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row text-center justify-content-center">
                <div class="col-lg-8 col-md-9 mb-4">
                    <div class="cards ">
                        <div *ngFor="let step of  uses ">
                            <div class="card p-base">
                                <span class="pbg"><app-icons-free-tools [name]="step.icon" /></span>
                                <div class="card-detail">
                                    <span class="card-title"> {{ step.title }}</span>
                                    <span class="card-descrition">{{ step.description }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </section>
    <section class="top-margin">
        <div class="container">
            <div class="introduction p-base">
                <div class="justify-content-center p-base">
                    <img src="/assets/images/punctuation/thesisgenerator.svg" alt="Thesis Statement Generator"
                        class="thesis-statement-generator-img" width="391px" height="338px">
                </div>
                <div class="statement-detail p-base">

                    <h2 class="statement-title"> Introduction to Thesis Statement Generator</h2>
                    <p class="statement-description">A thesis statement generator is designed to assist students,
                        writers, and researchers create clear and focused thesis
                        statements for their essays or research papers. It guides users through simple steps by asking
                        key questions about the
                        topic, main idea, and supporting points. This makes it easier to develop a strong and concise
                        central argument. Whether
                        you're a beginner or looking to improve your writing, a thesis statement generator provides
                        structure and clarity from
                        the start, making the writing process more efficient and organized.</p>
                </div>


            </div>
        </div>
    </section>

    <section class="top-margin">
        <div class="container">
            <div class="Secure p-base">
                <div class="statement-detail p-base">

                    <h2 class="statement-title"> Secure Your A+ Grade Using Our Thesis Statement Generator</h2>
                    <p class="statement-description">Getting an A+ grade starts with a strong thesis and our AI
                        <a href="/thesis-statement-generator" class="aTag">thesis statement generator </a> makes it easy
                        for
                        students. It helps you clearly show your
                        main idea and gives a clear outline for your argument or
                        research. This tool is perfect for students who want to impress their teachers and get good
                        grades. It’s made to ensure
                        every thesis you create meets academic standards and gives you a strong base for excellent
                        writing.
                    </p>
                </div>
                <div class="justify-content-center p-base">
                    <img src="/assets/images/punctuation/agrade.svg" alt="Thesis Statement Generator"
                        class="thesis-statement-generator-img" width="486px" height="485px">
                </div>



            </div>
        </div>
    </section>

    <section class="common-writing  top-margin">
        <div class="container">
            <div class="row text-center justify-content-center">
                <div class="time-line col-lg-12 col-md-12 col-12">
                    <div class="col-lg-5 col-md-12 col-12 me-lg-5 mt-md-4">
                        <h2 class="title mt-3 pr-md-5">
                            Key Features We Uphold for You
                        </h2>
                        <p class="description" style="padding-left: 0px">
                            We've built our intelligent tool on advanced processing technology that understands the
                            nuances of academic writing.
                            Here are some of its standout features that set our thesis generator apart:
                        </p>
                    </div>

                    <div class="col-lg-7 col-md-12 col-12 martop main-view mt-4">
                        <ul class="tl me-lg-5">
                            <li class="tl-item" *ngFor="let item of KeyFeatures; let i = index"
                                [class.active]="activeIndex === i" (click)="setActive(i)">
                                <h3 class="item-title ms-3">{{ item.title }}</h3>
                                <div class="item-detail ms-3" [innerHTML]="item.detail"></div>
                            </li>
                        </ul>
                    </div>


                </div>
            </div>
        </div>
    </section>
    <section class="top-margin">
        <div class="container">
            <div class="statement-generator">
                <div class="row text-center justify-content-center">
                    <div class="col-lg-8 col-md-9 mb-4">
                        <div class="statement-detail">
                            <h2 class="statement-title">
                                Multiple Thesis Statement Formats by GrammarIn
                            </h2>
                            <p class="statmente-description">Understanding that different assignments require different
                                approaches, GrammarIn carefully designed AI thesis statement
                                generator to accommodate specialized thesis types for every academic writing requirement
                                and assignment specification:</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="cards ">
                <div *ngFor="let step of  Formats ">
                    <div class="card p-base">
                        <span class="pbg"><app-icons-free-tools [name]="step.icon" /></span>
                        <div class="card-detail">
                            <span class="card-title"> {{ step.title }}</span>
                            <span class="card-descrition">{{ step.description }}</span>
                        </div>
                    </div>
                </div>
            </div>




        </div>
    </section>

    <section class="potential  top-margin">
        <div class="container">
            <div class="potential-bg mt-5 mb-5">
                <div class="row text-center justify-content-center">
                    <div class="col-lg-9 col-md-9 mb-4">
                        <h2 class="statement-title mt-5">
                            Things to Consider for Generating a Strong Thesis Statement
                        </h2>
                        <span class="statement-description">Even using the right thesis statement generator, strong
                            writing habits
                            matter. Here are four fundamentals to keep in
                            mind while generating thesis statements:
                        </span>
                    </div>
                </div>

                <div class="row points mt-4 mb-5">
                    <div class="col-lg-5">
                        <div class="">
                            <img src="/assets/images/punctuation/Generating-a-Strong-Thesis-Statement.png"
                                alt="Tab Image" class="potential-img-tab" width="460px" height="470px" />
                        </div>
                    </div>

                    <div class="col-lg-5 mtsmall">
                        <div class="vertical-tabs-container">
                            <div class="" id="faq-rows">
                                <div class="nav flex-column nav-pills" id="vertical-tab-list" role="tablist"
                                    aria-orientation="vertical">
                                    <div class="nav-link nav-pills vertical-tabs-pills mtsmall"
                                        [ngClass]="{ active: currentTab === 'tab1' }" (click)="currenttoggleTab('tab1')"
                                        id="vertical-first-tab" aria-controls="tab1" aria-expanded="false"
                                        class="mb-0 collapsed">
                                        <div>
                                            <h3 class="ms-3">
                                                <div class="d-flex" id="headPotential">
                                                    <div>
                                                        <span class=" potential-title">Keep It Concise and
                                                            Focused</span>
                                                    </div>
                                                </div>
                                            </h3>
                                            <div aria-labelledby="tab1" class="collapse"
                                                [ngClass]="{ show: currentTab === 'tab1' }" id="tab1" role="tabpanel"
                                                data-parent="#vertical-tab-list">
                                                <div class="card-body potential-content ms-3 me-3">
                                                    A strong thesis statement should be clear and to the point, ideally
                                                    one or two sentences. Avoid unnecessary words or
                                                    overly complex phrasing for engaging thesis statements.
                                                </div>
                                            </div>
                                        </div>

                                        <div>
                                            <img [src]="getIcon('tab1')" alt="writers and authors"
                                                class="float-right mt-3 mr-4 potential-icon" width="16px;"
                                                height="8.69px" />
                                        </div>
                                    </div>
                                    <div class="mb-2"></div>
                                    <div class="nav-link nav-pills vertical-tabs-pills"
                                        [ngClass]="{ active: currentTab === 'tab2' }" (click)="currenttoggleTab('tab2')"
                                        id="vertical-second-tab" aria-controls="tab2" aria-expanded="false"
                                        class="mb-0 collapsed">
                                        <div>
                                            <h3 class="ms-3">
                                                <div class="d-flex" id="headPotential">
                                                    <div>
                                                        <span class=" potential-title">Be Specific, not
                                                            Vague</span>
                                                    </div>
                                                </div>
                                            </h3>
                                            <div aria-labelledby="tab2" class="collapse"
                                                [ngClass]="{ show: currentTab === 'tab2' }" id="tab2" role="tabpanel"
                                                data-parent="#vertical-tab-list">
                                                <div class="card-body potential-content ms-3 me-3">
                                                    Input clear and detailed ideas into our free thesis statement
                                                    generator to produce a thesis accurately reflecting your
                                                    topic. Vague or generic entries will lead to weak statements. The
                                                    more specific your input, the more precise and
                                                    effective your thesis will guide your writing.
                                                </div>
                                            </div>
                                        </div>

                                        <div>
                                            <img [src]="getIcon('tab2')" alt="language learners"
                                                class="float-right mt-3 mr-4 potential-icon" width="16px;"
                                                height="8.69px" />
                                        </div>
                                    </div>
                                    <div class="mb-2"></div>
                                    <div class="nav-link nav-pills vertical-tabs-pills"
                                        [ngClass]="{ active: currentTab === 'tab3' }" (click)="currenttoggleTab('tab3')"
                                        id="vertical-third-tab" aria-controls="tab3" aria-expanded="false"
                                        class="mb-0 collapsed">
                                        <div>
                                            <h3 class="ms-3">
                                                <div class="d-flex" id="headPotential">
                                                    <div>
                                                        <span class=" potential-title">Avoid Broad
                                                            Generalisations
                                                        </span>
                                                    </div>
                                                </div>
                                            </h3>
                                            <div aria-labelledby="tab3" class="collapse"
                                                [ngClass]="{ show: currentTab === 'tab3' }" id="tab3" role="tabpanel"
                                                data-parent="#vertical-tab-list">
                                                <div class="card-body potential-content ms-3 me-3">
                                                    Don’t let the statement generator create overly broad claims that
                                                    are hard to support. Refine your topic before using
                                                    our tool so it generates a thesis with a clear scope. Narrowing your
                                                    focus ensures your argument remains manageable.
                                                </div>
                                            </div>
                                        </div>

                                        <div>
                                            <img [src]="getIcon('tab3')" alt="students & teachers"
                                                class="float-right mt-3 mr-4 potential-icon" width="16px;"
                                                height="8.69px" />
                                        </div>
                                    </div>
                                    <div class="mb-2 osmal"></div>

                                    <div class="nav-link nav-pills vertical-tabs-pills"
                                        [ngClass]="{ active: currentTab === 'tab4' }" (click)="currenttoggleTab('tab4')"
                                        id="vertical-forth-tab" aria-controls="tab4" aria-expanded="false"
                                        class="mb-0 collapsed">
                                        <div>
                                            <h3 class="ms-3">
                                                <div class="d-flex" id="headPotential">
                                                    <div>
                                                        <span class=" potential-title">Make Sure It’s
                                                            Debatable
                                                        </span>
                                                    </div>
                                                </div>
                                            </h3>
                                            <div aria-labelledby="tab4" class="collapse"
                                                [ngClass]="{ show: currentTab === 'tab4' }" id="tab4" role="tabpanel"
                                                data-parent="#vertical-tab-list">
                                                <div class="card-body potential-content ms-3 me-3">
                                                    Our AI thesis statement generator creates theses that share an
                                                    opinion or point of view. A strong thesis should be
                                                    something people could agree or disagree with. It makes your writing
                                                    more interesting and gives you something to explain
                                                    and support with evidence.
                                                </div>
                                            </div>
                                        </div>

                                        <div>
                                            <img [src]="getIcon('tab4')" alt="business professionals"
                                                class="float-right mt-3 mr-4 potential-icon" width="16px;"
                                                height="8.69px" />
                                        </div>
                                    </div>
                                    <div class="mb-2 osmal"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </section>


    <section class="fqa margin-top-bottom top-margin">
        <div class="container">
            <div class="row text-center justify-content-center">
                <div class="col-lg-9 col-12 mb-md-4 mb-2">
                    <h2 class="headings">Frequently Asked Questions</h2>
                </div>
            </div>

            <div class="v-pills-tab-list">
                <div class="" id="row_faqs">
                    <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                        <div class="container container-grid" style="width: min(100% - 40px, 768px)">
                            <div class="nav-link nav-pills" [ngClass]="{ active: activeTab === 'q1' }"
                                (click)="toggleTab('q1')" id="v-pills-first-tab" aria-controls="q1"
                                aria-expanded="false">
                                <div class="nav-linkFAQ">
                                    <h3 class="card-header" [class.closed]="activeTab !== 'q1'">
                                        How Does This AI Thesis Statement Generator Work?
                                    </h3>
                                    <app-icons-free-tools name="plusIcon" *ngIf="activeTab !== 'q1'" />
                                    <app-icons-free-tools name="minusIcon" *ngIf="activeTab === 'q1'" />
                                </div>

                                <div aria-labelledby="q1" class="collapse" [ngClass]="{ show: activeTab === 'q1' }"
                                    id="q1" role="tabpanel" data-parent="#v-pills-tab-list">
                                    <div class="card-body">
                                        This AI Thesis Statement Generator guides you through simple questions about
                                        your topic, main idea, and supporting
                                        points. Once you enter the information, the tool analyzes your input using
                                        intelligent algorithms and creates a clear,
                                        focused, and grammatically correct thesis statement.
                                    </div>
                                </div>
                            </div>

                            <div class="nav-link nav-pills" [ngClass]="{ active: activeTab === 'q2' }"
                                (click)="toggleTab('q2')" id="v-pills-2nd-tab" aria-controls="q2" aria-expanded="false">
                                <div class="d-flex nav-linkFAQ">
                                    <h3 class="card-header" [class.closed]="activeTab !== 'q2'">
                                        Is the Generated Thesis Statement Unique and Plagiarism-Free?

                                    </h3>

                                    <app-icons-free-tools name="plusIcon" *ngIf="activeTab !== 'q2'" />
                                    <app-icons-free-tools name="minusIcon" *ngIf="activeTab === 'q2'" />
                                </div>

                                <div aria-labelledby="q2" class="collapse" [ngClass]="{ show: activeTab === 'q2' }"
                                    id="q2" role="tabpanel" data-parent="#v-pills-tab-list">
                                    <div class="card-body">
                                        Yes, the generated thesis statement is <a href="/plagiarism-checker"
                                            class="aTag"> unique and plagiarism-free </a>. The AI creates each statement
                                        based on your specific
                                        inputs, ensuring original content tailored to your topic. You can confidently
                                        use it for academic or professional
                                        purposes without worrying about duplication.

                                    </div>
                                </div>
                            </div>

                            <div class="nav-link nav-pills" [ngClass]="{ active: activeTab === 'q3' }"
                                (click)="toggleTab('q3')" id="v-pills-3rd-tab" aria-controls="q3" aria-expanded="false">
                                <div class="nav-linkFAQ">
                                    <h3 class="card-header" [class.closed]="activeTab !== 'q3'">
                                        Can I Edit the Thesis Statement After It's Generated?
                                    </h3>

                                    <app-icons-free-tools name="plusIcon" *ngIf="activeTab !== 'q3'" />
                                    <app-icons-free-tools name="minusIcon" *ngIf="activeTab === 'q3'" />
                                </div>

                                <div aria-labelledby="q3" class="collapse" [ngClass]="{ show: activeTab === 'q3' }"
                                    id="q3" role="tabpanel" data-parent="#v-pills-tab-list">
                                    <div class="card-body">
                                        Yes, you can easily edit the thesis statement after it's generated. It gives you
                                        a strong starting point, and you can
                                        adjust the wording to better suit your writing style or specific requirements.
                                    </div>
                                </div>
                            </div>

                            <div class="nav-link nav-pills" [ngClass]="{ active: activeTab === 'q4' }"
                                (click)="toggleTab('q4')" id="v-pills-4th-tab" aria-controls="q4" aria-expanded="false">
                                <div class="nav-linkFAQ">
                                    <h3 class="card-header faqHeading" [class.closed]="activeTab !== 'q4'">
                                        Can I Use This Thesis Statement Generator for Any Subject?
                                    </h3>

                                    <app-icons-free-tools name="plusIcon" *ngIf="activeTab !== 'q4'" />
                                    <app-icons-free-tools name="minusIcon" *ngIf="activeTab === 'q4'" />
                                </div>

                                <div aria-labelledby="q4" class="collapse" [ngClass]="{ show: activeTab === 'q4' }"
                                    id="q4" role="tabpanel" data-parent="#v-pills-tab-list">
                                    <div class="card-body">
                                        Sure! You can confidently employ our tool for any subject. From Art History to
                                        Zoology and everything in between.
                                    </div>
                                </div>
                            </div>

                            <div class="nav-link nav-pills" [ngClass]="{ active: activeTab === 'q5' }"
                                (click)="toggleTab('q5')" id="v-pills-5th-tab" aria-controls="q5" aria-expanded="false">
                                <div class="nav-linkFAQ">
                                    <h3 class="card-header faqHeading" [class.closed]="activeTab !== 'q5'">
                                        Is the Thesis Statement Suitable for Academic Use?
                                    </h3>

                                    <app-icons-free-tools name="plusIcon" *ngIf="activeTab !== 'q5'" />
                                    <app-icons-free-tools name="minusIcon" *ngIf="activeTab === 'q5'" />
                                </div>

                                <div aria-labelledby="q5" class="collapse" [ngClass]="{ show: activeTab === 'q5' }"
                                    id="q5" role="tabpanel" data-parent="#v-pills-tab-list">
                                    <div class="card-body">
                                        Yes, the thesis statement is designed to meet academic standards. It is clear,
                                        focused, and structured to support
                                        essays, research papers, and other academic writing.

                                    </div>
                                </div>
                            </div>

                            <div class="nav-link nav-pills" [ngClass]="{ active: activeTab === 'q6' }"
                                (click)="toggleTab('q6')" id="v-pills-6th-tab" aria-controls="q6" aria-expanded="false">
                                <div class="nav-linkFAQ">
                                    <h3 class="card-header faqHeading" [class.closed]="activeTab !== 'q6'">
                                        Can I Generate Multiple Versions of a Thesis Statement?
                                    </h3>

                                    <app-icons-free-tools name="plusIcon" *ngIf="activeTab !== 'q6'" />
                                    <app-icons-free-tools name="minusIcon" *ngIf="activeTab === 'q6'" />
                                </div>

                                <div aria-labelledby="q6" class="collapse" [ngClass]="{ show: activeTab === 'q6' }"
                                    id="q6" role="tabpanel" data-parent="#v-pills-tab-list">
                                    <div class="card-body">
                                        Absolutely. Using this tool, you may generate as many responses as you need
                                        until you find one that perfectly resonates
                                        with your paper.
                                    </div>
                                </div>
                            </div>

                            <div class="nav-link nav-pills" [ngClass]="{ active: activeTab === 'q7' }"
                                (click)="toggleTab('q7')" id="v-pills-7th-tab" aria-controls="q7" aria-expanded="false">
                                <div class="nav-linkFAQ">
                                    <h3 class="card-header faqHeading" [class.closed]="activeTab !== 'q7'">
                                        Is This AI Thesis Statement Generator Free to Use?
                                    </h3>
                                    <app-icons-free-tools name="plusIcon" *ngIf="activeTab !== 'q7'" />
                                    <app-icons-free-tools name="minusIcon" *ngIf="activeTab === 'q7'" />
                                </div>

                                <div aria-labelledby="q7" class="collapse" [ngClass]="{ show: activeTab === 'q7' }"
                                    id="q7" role="tabpanel" data-parent="#v-pills-tab-list">
                                    <div class="card-body">
                                        Yes, this AI Thesis Statement Generator is free to use. You can create precise
                                        and effective thesis statements without
                                        cost or required sign-up.

                                    </div>
                                </div>
                            </div>

                            <div class="nav-link nav-pills" [ngClass]="{ active: activeTab === 'q8' }"
                                (click)="toggleTab('q8')" id="v-pills-8th-tab" aria-controls="q8" aria-expanded="false">
                                <div class="nav-linkFAQ">
                                    <h3 class="card-header faqHeading" [class.closed]="activeTab !== 'q8'">
                                        Does It Work Well on Both Desktop and Mobile?
                                    </h3>
                                    <app-icons-free-tools name="plusIcon" *ngIf="activeTab !== 'q8'" />
                                    <app-icons-free-tools name="minusIcon" *ngIf="activeTab === 'q8'" />
                                </div>

                                <div aria-labelledby="q8" class="collapse" [ngClass]="{ show: activeTab === 'q8' }"
                                    id="q8" role="tabpanel" data-parent="#v-pills-tab-list">
                                    <div class="card-body">
                                        Yes! The responsive interface works flawlessly whether you are using it on a
                                        desktop or mobile.

                                    </div>
                                </div>
                            </div>
                            <div class="nav-link nav-pills" [ngClass]="{ active: activeTab === 'q9' }"
                                (click)="toggleTab('q9')" id="v-pills-9th-tab" aria-controls="q9" aria-expanded="false">
                                <div class="nav-linkFAQ">
                                    <h3 class="card-header faqHeading" [class.closed]="activeTab !== 'q9'">
                                        Is It Okay to Use This for Research Papers and Essays?
                                    </h3>
                                    <app-icons-free-tools name="plusIcon" *ngIf="activeTab !== 'q9'" />
                                    <app-icons-free-tools name="minusIcon" *ngIf="activeTab === 'q9'" />
                                </div>

                                <div aria-labelledby="q9" class="collapse" [ngClass]="{ show: activeTab === 'q9' }"
                                    id="q9" role="tabpanel" data-parent="#v-pills-tab-list">
                                    <div class="card-body">
                                        Yes, using this tool for research papers and essays is perfectly okay.

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

</main> -->





<a (click)="scrollToTop()" *ngIf="shouldShowButton" id="scroll-to-top" title="Go to top">
    <svg id="i-chevron-top" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="15" height="32" fill="none"
        stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3">
        <path d="M30 20 L16 8 2 20" />
    </svg>
</a>

<app-footer></app-footer>